import React from 'react'
import { useTranslation } from 'react-i18next'
import { TitleController } from '@pandiafi/design-system'
import {
  ResidentAppAsideSection,
  ResidentAppAsideText,
  ResidentAppBackLink,
  ResidentAppCard,
  ResidentAppView,
} from '@pandiafi/components'

import { ReservationCalendars } from '../ReservationCalendars'
import { useModuleConfig } from '../../hooks/useModuleConfig/useModuleConfig'
import { ReservationsList } from '../../components/ReservationsList'
import { useContractPaths } from '../../hooks/useContractPaths/useContractPaths'
import { useCurrentContract } from '../../hooks/useCurrentContract/useCurrentContract'

import { ReservationRulesAndTermsLinks } from 'components'

export const SaunaReservations: React.FC = () => {
  const { t } = useTranslation(['common', 'reservations', 'titles'])
  const moduleConfig = useModuleConfig()
  const { frontPagePath } = useContractPaths()
  const { currentContractId } = useCurrentContract()

  const saunaConfig = moduleConfig.sauna
  const saunaFallbackLinks: { href: string; label: string }[] = []
  if (saunaConfig?.contractDocumentLink) {
    saunaFallbackLinks.push({
      href: saunaConfig.contractDocumentLink,
      label: t('reservations:modal.saunaRulesLink'),
    })
  }
  if (saunaConfig?.termsOfUseDocumentLink) {
    saunaFallbackLinks.push({
      href: saunaConfig.termsOfUseDocumentLink,
      label: t('reservations:modal.commonAreaTermsLink'),
    })
  }

  return (
    <TitleController
      title={t('titles:saunaReservations', 'Sauna reservations')}
    >
      <ResidentAppView
        title={t('reservations:pageTitleSauna')}
        backLink={
          <ResidentAppBackLink href={frontPagePath}>
            {t('common:views.home')}
          </ResidentAppBackLink>
        }
        aside={
          <ResidentAppAsideSection>
            <ResidentAppAsideText>
              {t(
                'reservations:saunaSidebarDescription',
                'Täällä voit tarkastella saunavuoroja ja varata oman saunavuoron valitsemalla vapaan ajan tai painamalla Varaa'
              )}
            </ResidentAppAsideText>
            <ReservationRulesAndTermsLinks
              contractId={currentContractId}
              reservableCategory="house_sauna"
              realPropertyHierarchyId={null}
              fallbackLinks={saunaFallbackLinks}
            />
            <ReservationsList reservableCategory="house_sauna" />
          </ResidentAppAsideSection>
        }
      >
        <ResidentAppCard>
          <ReservationCalendars reservableCategory="house_sauna" />
        </ResidentAppCard>
      </ResidentAppView>
    </TitleController>
  )
}
